import { API_BASE_URL } from '../client';

export const DASHBOARD_ENDPOINTS = {
  DASHBOARD: {
    STATS: `${API_BASE_URL}/dashboard/stats`,
    PROJECTS: `${API_BASE_URL}/dashboard/projects`,
    REPORT: `${API_BASE_URL}/dashboardReport`,
    REPORT_SAVE: `${API_BASE_URL}/dashboardReport/save`,
  },
} as const;
